import React from 'react';

import { BasicSelect } from 'components/FormSelection/FormSelection';

import { getIntegrationTypesConstant } from 'utils/general';

import styles from './Filter.module.css';
import intl from 'react-intl-universal';

const { LISTING_TYPE } = getIntegrationTypesConstant();

const Filter = ({
  type,
  propertyOptions,
  unitOptions,
  hostOptions,
  selectedPropertyId,
  selectedUnitId,
  selectedPropertyHostId,
  onChangeProperty,
  onChangeUnit,
  onChangeHost,
  checkIsAdmin
}) => {
  const isListingIntegration = type === LISTING_TYPE.code;

  // Determine how many selectors will be shown
  const selectorCount = (checkIsAdmin ? 1 : 0) + 1 + (isListingIntegration ? 1 : 0);

  // Get the appropriate class based on number of visible selectors
  const getSelectClass = () => {
    if (selectorCount === 3) {
      return styles.selectionThird;
    } else if (selectorCount === 2) {
      return styles.selectionHalf;
    } else {
      return styles.selectionFull;
    }
  };

  const handleHostChange = selectedHostId => {
    const selectedHost = hostOptions.find(option => option.value === selectedHostId);
    onChangeHost(selectedHost.value, selectedHost.children || []);
  };

  return (
    <div className={styles.selectionRow}>
      {checkIsAdmin && (
        <BasicSelect
          label={intl.get('hostConnect.integration.headerLabels.host').d('Host')}
          selections={hostOptions}
          value={selectedPropertyHostId}
          placeholder={intl.get('hostConnect.integration.placeholder.host').d('There is no host available')}
          className={getSelectClass()}
          selectClassName={styles.selectionBody}
          onChange={handleHostChange}
        />
      )}
      <BasicSelect
        label={intl.get('hostConnect.integration.headerLabels.property').d('Property')}
        selections={propertyOptions}
        value={selectedPropertyId}
        placeholder={intl.get('hostConnect.integration.placeholder.property').d('There is no property available')}
        className={getSelectClass()}
        selectClassName={styles.selectionBody}
        onChange={onChangeProperty}
      />
      {isListingIntegration && (
        <BasicSelect
          label={intl.get('hostConnect.integration.headerLabels.unit').d('Unit')}
          selections={unitOptions}
          value={selectedUnitId}
          placeholder={intl.get('hostConnect.integration.placeholder.unit').d('This property has no unit')}
          className={getSelectClass()}
          selectClassName={styles.selectionBody}
          onChange={onChangeUnit}
        />
      )}
    </div>
  );
};

export default Filter;
